<template>
    <v-container>
        <v-row align="center">

            <v-col cols="3" md="2" lg="1">
                <back-button/>
            </v-col>

            <v-slide-y-transition>
                <template v-show="!loadingUser && studentInvitations.length > 0">
                    <v-col cols="9" md="10" lg="11">
                        <v-alert dense border="left" color="grey lighten-2" class="black--text my-0">
                            <small>{{ $t('student.invitations_subtitle') }}.</small>
                        </v-alert>
                    </v-col>
                </template>
            </v-slide-y-transition>

            <v-col cols="12" md="6" class="mx-auto">

                <template v-if="!showInvitations">
                    <v-skeleton-loader type="list-item-avatar-three-line"/>
                    <v-skeleton-loader type="list-item-avatar-three-line"/>
                    <v-skeleton-loader type="list-item-avatar-three-line"/>
                </template>

                <template v-if="invitationsLoaded">
                    <v-list three-line v-show="showInvitations" class="text-center">
                        <small v-if="studentInvitations.length === 0">{{ $t('coach.no_invitations') }}</small>
                        <student-invitation-card
                            v-for="invitation in studentInvitations"
                            :key="invitation.id"
                            @accept="onInvitationAccept"
                            :invitation="invitation"/>
                    </v-list>
                </template>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>

import StudentInvitationCard from "@/components/common/cards/StudentInvitationCard";
import {mapState, mapActions} from 'vuex'
import BackButton from "@/components/common/BackButton";

export default {
    components: {
        BackButton,
        StudentInvitationCard,
    },
    data() {
        return {
            showInvitations: false,
            invitationsLoaded: false,
        }
    },
    computed: {
        ...mapState(['loadingUser', 'studentInvitations']),
    },
    methods: {
        ...mapActions(['bindStudentInvitations']),
        onInvitationAccept() {
            const vm = this
            vm.goHome()
        },
        setInvitationsLoaded() {
            const vm = this
            vm.invitationsLoaded = true
            setTimeout(function () {
                vm.showInvitations = true
            }, 500)
        }
    },
    async mounted() {
        const vm = this
        if (!vm.currentUser) return vm.setInvitationsLoaded()
        if (vm.studentInvitations.length === 0) await vm.bindStudentInvitations(vm.currentUser.email)
        vm.setInvitationsLoaded()
    },
}
</script>
